import { render, staticRenderFns } from "./homes.vue?vue&type=template&id=008ca153&scoped=true"
import script from "./homes.vue?vue&type=script&lang=js"
export * from "./homes.vue?vue&type=script&lang=js"
import style0 from "./homes.vue?vue&type=style&index=0&id=008ca153&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008ca153",
  null
  
)

export default component.exports